export default {"src":"/_next/static/media/left_align_logo.0d965702.svg","height":54,"width":268};